import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#0d3475",
      light: "#3D5C90",
      dark: "#092451",
    },
    secondary: {
      main: "#bec6d9",
      light: "#CBD1E0",
      dark: "#858A97",
      contrastText: "#092451",
    },
    error: {
      main: "#c21a27",
      light: "#CE4752",
      dark: "#87121B",
      contrastText: "#ffffff",
    },
    warning: {
      main: "#f39710",
      light: "#F5AB3F",
      dark: "#AA690B",
    },
    info: {
      main: "#0575b4",
      light: "#3790C3",
      dark: "#03517D",
    },
    success: {
      main: "#4ea04b",
      light: "#71B36F",
      dark: "#367034",
    },
    background: {
      default: "#f5f5f5",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2.5rem",
      fontWeight: 500,
      "@media (max-width:600px)": {
        fontSize: "2rem",
      },
    },
    h2: {
      fontSize: "2rem",
      fontWeight: 500,
      "@media (max-width:600px)": {
        fontSize: "1.8rem",
      },
    },
    h3: {
      fontSize: "1.8rem",
      fontWeight: 500,
      "@media (max-width:600px)": {
        fontSize: "1.6rem",
      },
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: "none",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        },
      },
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

export default theme;
